import * as TypeGraphQL from "type-graphql";
export var VolumeLevel;
(function (VolumeLevel) {
    VolumeLevel["VERY_LOW"] = "VERY_LOW";
    VolumeLevel["LOW"] = "LOW";
    VolumeLevel["MEDIUM"] = "MEDIUM";
    VolumeLevel["HIGH"] = "HIGH";
    VolumeLevel["VERY_HIGH"] = "VERY_HIGH";
})(VolumeLevel || (VolumeLevel = {}));
TypeGraphQL.registerEnumType(VolumeLevel, {
    name: "VolumeLevel",
    description: undefined,
});
//# sourceMappingURL=VolumeLevel.js.map